import { useState } from 'react';
import { Photo } from '../../../../graphql/graphql';
import { ThumbnailImage, ThumbnailWrapper } from './styled';
import { FullScreenGallery } from '../../../ui/FullScreenGallery';
import { ResidenceGalleryFooter } from '../../PhotosGallery/ResidenceGalleryFooter';
import { ResidenceGalleryHeader } from '../../PhotosGallery/ResidenceGalleryHeader';

interface GalleryThumbnailProps {
  photos: Photo[];
  galleryDescription: string;
  priceInfo: string;
}

export const GalleryThumbnail: React.FC<GalleryThumbnailProps> = ({
  photos,
  galleryDescription,
  priceInfo
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <ThumbnailWrapper
        onClick={onOpenModal}
        data-stat="residence-construction"
      >
        <ThumbnailImage src={photos[0].full} alt="" width={335} height={112} />
      </ThumbnailWrapper>
      {isModalOpen && (
        <FullScreenGallery
          description={galleryDescription}
          isOpen={isModalOpen}
          photos={photos}
          initialGalleryIndex={1}
          renderDesktopCarousel={false}
          footer={
            <ResidenceGalleryFooter
              galleryDescription={galleryDescription}
              priceInfo={priceInfo}
              showPhoneButton={false}
            />
          }
          onClose={handleCloseModal}
          renderHeader={currentPage => (
            <ResidenceGalleryHeader
              galleryDescription={galleryDescription}
              priceInfo={priceInfo}
              pageNumber={currentPage}
              photosLength={photos.length}
              onClose={handleCloseModal}
              showPhoneButton={false}
            />
          )}
        />
      )}
    </>
  );
};
